import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Link, PageSection, useGlobal } from '@rcg/ui-react';
import { Box } from '@material-ui/core';
import { isMobile } from 'react-device-detect';
import { getManageRedirectionUrl } from '../../utils/common';
import Dictionary from '../../utils/dictionary';
import useStyles from './index.style';
import BrowseForm from '../../components/BrowseForm';
import { trackSearchView } from '../../utils/analytics/browseTracking';

const Browse = () => {
  const { renderContent } = useGlobal();
  const classes = useStyles();

  useEffect(() => {
    if (document.getElementsByClassName('route')[0]) {
      document.getElementsByClassName('route')[0].className = 'route-search';
    }
    trackSearchView();
  }, []);

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex" />
      </Helmet>
      <Box className={classes.mainContainer}>
        <Box className={classes.contentContainer}>
          <PageSection
            className={classes.pageSection}
            title={renderContent(
              Dictionary.airBrowsePageTitle.key,
              Dictionary.airBrowsePageTitle.defaultValue,
            )}
            description={renderContent(
              Dictionary.airBrowsePageDescription.key,
              Dictionary.airBrowsePageDescription.defaultValue,
            )}
          />
          <BrowseForm isMobile={isMobile} />
          <Link underline="none" href={getManageRedirectionUrl()} className={classes.goReservation}>
            {renderContent(
              Dictionary.airBrowsePageBottomCta.key,
              Dictionary.airBrowsePageBottomCta.defaultValue,
            )}
          </Link>
        </Box>
      </Box>
    </>
  );
};

export default Browse;
